// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-auth{display:flex;flex-wrap:wrap;gap:14px}.social-auth--button{display:inline-flex;padding:8px 22px;align-items:center;justify-content:center;gap:8px;border-radius:4px;border:1px solid rgba(30,36,50,.23);font-size:16px;white-space:nowrap;flex:1 0 calc(33.333% - 14px)}.social-auth--button-icon{width:24px;height:24px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
